import logo from './logo.svg';
import './App.css';

import { BrowserRouter, Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { useEffect } from 'react';
import Authorize from './router/Authorize';
import Home from './views/Home';
import ManagePackage from './views/ManagePackage';
import SearchMember from './views/SearchMember';
import SearchUserPackage from './views/SearchUserPackage';
import Login from './views/Login';
import NotFound from './views/NotFound';
import DefaultContainer from './views/DefaultContainer';

function App(props) {

  useEffect(() => {
  }, [])


  return (
    <BrowserRouter>

      <Routes>
        <Route path="/login" element={ <Login />} />

        <Route element={<DefaultContainer/>}>
          <Route path="/" element={<Authorize><Home /></Authorize>} />
          <Route path="/manage-package" element={<Authorize><ManagePackage /></Authorize>} />
          <Route path="/search-member" element={<Authorize><SearchMember /></Authorize>} />
          <Route path="/search-user-package" element={<Authorize><SearchUserPackage /></Authorize>} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Route>

      </Routes>
   

    </BrowserRouter>
  );
}

export default App;
